import { PageHero } from "@/components/site/PageHero";
import type { LegalBlock } from "@/content/legal";

export function LegalPage({ title, blocks }: { title: string; blocks: LegalBlock[] }) {
  return (
    <>
      <PageHero maxWidth="6xl" headline={title} />
      <section className="bg-background">
        <div className="mx-auto max-w-3xl px-6 py-14 md:py-20">
          <div className="space-y-4 text-base leading-relaxed text-muted-foreground">
            {blocks.map((b, i) =>
              b.t === "h" ? (
                <h2 key={i} className="pt-6 font-display text-2xl text-ink first:pt-0">
                  {b.x}
                </h2>
              ) : b.t === "li" ? (
                <p key={i} className="border-l-2 border-primary/30 pl-4">
                  {b.x.replace(/^•\s*/, "")}
                </p>
              ) : (
                <p key={i}>{b.x}</p>
              ),
            )}
          </div>
        </div>
      </section>
    </>
  );
}
